import React from "react";
import { styled } from "@mui/system";

// Styled skeletons matching FeaturedPropertyCard
const GradientBorderWrapper = styled("div")({
	position: "relative",
	borderRadius: "2rem",
	overflow: "visible",
	display: "inline-block",
});

const GradientBorder = styled("div")({
	content: '""',
	position: "absolute",
	inset: 0,
	borderRadius: "1.5rem",
	zIndex: 0,
	pointerEvents: "none",
	background: "linear-gradient(360deg, #B05920 0%, #FFD5B2 100%)",
	padding: 3,
	WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
	WebkitMaskComposite: "xor",
	maskComposite: "exclude",
});

const PropertyCardContainer = styled("div")({
	display: "flex",
	flexDirection: "row",
	justifyContent: "space-between",
	alignItems: "center",
	scrollSnapAlign: "start",
	flexShrink: 1,
	flexGrow: 1,
	borderRadius: "1.5rem",
	overflow: "hidden",
	transition: "all 0.2s ease",
	background: "linear-gradient(0deg, #FFEBDB 0%, #FFF 100%)",
	width: "43.75rem",
	height: "15.875rem",
});

const PropertyCardInfoContainer = styled("div")({
	display: "flex",
	flexDirection: "column",
	justifyContent: "space-around",
	alignItems: "space-around",
	padding: "1rem",
	gap: "1rem",
	width: "24.5rem",
	height: "15.25rem",
});

interface SkeletonBoxProps {
	width?: string;
	height?: string;
	borderRadius?: string;
}

const SkeletonBox = styled("div", {
	shouldForwardProp: (prop) => prop !== "width" && prop !== "height" && prop !== "borderRadius",
})<SkeletonBoxProps>(({ theme, width = "100%", height = "1.5rem", borderRadius = "0.5rem" }) => ({
	width,
	height,
	borderRadius,
	background: theme.palette.action.selected, // MUI default skeleton color
	marginBottom: "0.75rem",
	animation: "skeleton-loading 1.2s infinite ease-in-out alternate",
	"@keyframes skeleton-loading": {
		from: { opacity: 1 },
		to: { opacity: 0.5 },
	},
}));

const BeegruTopPickPropertyLoadingCard = () => (
	<GradientBorderWrapper>
		<GradientBorder />
		<PropertyCardContainer>
			{/* Image skeleton */}
			<SkeletonBox
				width="15rem"
				height="15.875rem"
				borderRadius="1.5rem 0 0 1.5rem"
			/>
			<PropertyCardInfoContainer>
				{/* Builder skeleton */}
				<SkeletonBox
					width="8rem"
					height="2rem"
				/>
				{/* Price skeleton */}
				<SkeletonBox
					width="6rem"
					height="2rem"
				/>
				{/* Title skeleton */}
				<SkeletonBox
					width="12rem"
					height="2rem"
				/>
				{/* Property type skeleton */}
				<SkeletonBox
					width="10rem"
					height="1.5rem"
				/>
				{/* Button skeleton */}
				<SkeletonBox
					width="100%"
					height="2.5rem"
					borderRadius="0.75rem"
				/>
			</PropertyCardInfoContainer>
		</PropertyCardContainer>
	</GradientBorderWrapper>
);

export default BeegruTopPickPropertyLoadingCard;
